/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Sajeenthiran's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Sajeenthiran Parameswaran Portfolio",
    type: "website",
    url: "http://ashutoshhathidara.com/",
  },
};

//Home Page
const greeting = {
  title: "Sajeenthiran Parameswaran",
  logo_name: "Sajeenthiran Parameswaran",
  nickname: "",
  subTitle:
    "I am a passionate individual with a growth mindset who is willing to undertake challenges and learn new things.",
  resumeLink:
    "https://drive.google.com/file/d/1YDhg63lmhAvkyhVXGJv0WDoFt1YhbGs6/view?usp=sharing",
  portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
  githubProfile: "https://github.com/ParameswaranSajeenthiran",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/ParameswaranSajeenthiran",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/parameswaran-sajeenthiran",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:psajeendran@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  }
  ,
  // {
  //   name: "X-Twitter",
  //   link: "https://twitter.com/ashutosh_1919",
  //   fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
  //   backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  // },
  {
    name: "Facebook",
    link: "https://www.facebook.com/sajee.parameswar",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/sajeenthiran.p/?hl=en",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Data Analysis and Visualization",
        "⚡ Develop models for various deeplearning and statistical use cases",
        "⚡ Experience in working with Computer Vision and NLP projects",
        "⚡ Apply Cloud ML services for better model deployment and scalability",
      ],
      softwareSkills: [
        
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:numpy",
          style: {
            backgroundColor: "transparent",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Cloud Computing & DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Working experince in deploying and maintaining projects on virtual machine instances along with integration of databases",
        "⚡ Experience in working with AWS, Azure and GCP services",
      ],
      softwareSkills: [
        // {
        //   skillName: "GCP",
        //   fontAwesomeClassname: "simple-icons:googlecloud",
        //   style: {
        //     color: "#4285F4",
        //   },
        // },

        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        ,
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "simple-icons:jenkins",
          
        },
        {
          skillName: "Ansible",
          fontAwesomeClassname: "simple-icons:ansible",
          
        },

      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Robust in developing Backend using NodeJS, ExpressJS, Spring Boot and Django",
        "⚡ Building web apps using modern web technologies",
        "⚡ Develop mobile applications using  React Native and solo android apps using android Studio",
        
      ],
      softwareSkills: [
       
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        

        ,
        {
          skillName: "Android Studio",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#78C257",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "simple-icons:spring",
          style: {
            color: "#6DB33F",
          },
        }
       ,
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "simple-icons:mysql",
         
        },
      ],
    },
    
    
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    // {
    //   siteName: "LeetCode",
    //   iconifyClassname: "simple-icons:leetcode",
    //   style: {
    //     color: "#F79F1B",
    //   },
    //   profileLink: "https://leetcode.com/layman_brother/",
    // },
    // {
    //   siteName: "HackerRank",
    //   iconifyClassname: "simple-icons:hackerrank",
    //   style: {
    //     color: "#2EC866",
    //   },
    //   profileLink: "https://www.hackerrank.com/layman_brother",
    // },
    // {
    //   siteName: "Codechef",
    //   iconifyClassname: "simple-icons:codechef",
    //   style: {
    //     color: "#5B4638",
    //   },
    //   profileLink: "https://www.codechef.com/users/ashutosh_1919",
    // },
    // {
    //   siteName: "Codeforces",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "http://codeforces.com/profile/layman_brother",
    // },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@ashutosh391",
    // },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/laymanbrother",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Bsc (hons). Computer Science and Engineering , Specializing in Data Science and Engineering", 
      subtitle: " University of Moratuwa ,Katubeddah ",
      logo_path: "uom_logo.png",
      alt_name: "UOM",
      duration: "2022 - present",
      descriptions: [
        "⚡ Masterd Basic Principles in Computer Science and Engineering such as Data Structures, Algorithms, Operating Systems, Computer Networks, Database Management Systems, Computer Archeitecture etc.",
        "⚡ During the latter Part of the degree, I am specializing in Data Science and Engineering , were I have taken courses on Machine Learning, Deep Learning, Data Mining, Big Data, Natural Language Processing etc.",
        "⚡ Apart from this, contributed to projects where applying the knowlegde on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ Dean's List in the first , second and third semesters",
        "⚡ CGPA : 3.98/4.00",
      ],
      website_link: "https://cse.mrt.ac.lk/",
    },
    {
      title: "Full Stack Web Development",
      subtitle: "Uki.life ",
      logo_path: "uki.png",
      alt_name: "UKI Life",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ 6 extensive months of Full Stack Web Development training.",
        "⚡ Mastered React JS, Spring Boot, MongoDB, HTML, CSS, JavaScript, Bootstrap, Material UI, Git, Github, Heroku ",
        "⚡ 6 months Intership at Senzmate  as a Full Stack Developer",
      ],
      website_link: "https://www.uki.life/",
    },
    // {
    //   title: "Advance Level (Physical Science)",
    //   subtitle: "D.S. Senanayake College, Colombo",
    //   logo_path: "DS.png",
    //   alt_name: "UKI Life",
    //   duration: "2021 - 2023",
    //   descriptions: [
    //     "⚡Physics- A , Chemistry - A , Combined Mathematics (Pure and Applied) - A",
    //     "⚡ Island rank -215",
        
    //   ],
    //   website_link: "https://dssenanayakecollege.lk/",
    // },
    // {
    //   title: "Ordinary Level ",
    //   subtitle: "Alethea  School , Colombo",
    //   logo_path: "alethea.png",
    //   alt_name: "Alethea School",
    //   duration: "2021 - 2023",
    //   descriptions: [
    //     "⚡9A's",
    //     "⚡Developed team work and leadership skills through various extra curricular activities and sports , such as Scouting , Chess and Atheletics",
        
    //   ],
    //   website_link: "https://alethea.lk/",
    // }
  ],
};

const certifications = {
  certifications: [
    {
      title: "AWS Academy Graduate - AWS Academy Machine Learning Foundations",
      subtitle: "- AWS Educate",
      logo_path: "aws academy.png",
      certificate_link:
        "https://www.credly.com/badges/8d65e404-40b0-40d3-bed2-73d395b4a11b/linked_in_profile",
      alt_name: "Stanford University",
      color_code: "white",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://coursera.org/share/6313b067785aae9ed78bdcc754f48787",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    // {
    //   title: "ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    {
      title: "Kaggle",
      subtitle: "-kaggle learn",
      logo_path: "kaggle.png",
      certificate_link:
        "https://www.kaggle.com/sajeenthiranp",
      alt_name: "IBM",
      color_code: "white",
    },
    // {
    //   title: "Big Data",
    //   subtitle: "- Kim Akers",
    //   logo_path: "microsoft_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
    //   alt_name: "Microsoft",
    //   color_code: "#D83B0199",
    // },
    // {
    //   title: "Advanced Data Science",
    //   subtitle: "- Romeo Kienzler",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work & Internship ",
  description:
    "",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Associate Software Developer (Part Time / Remote)",
          company: "Senzmate",
          company_url: "https://www.senzmate.com/",
          logo_path: "senzmate.png",
          duration: "Jan 2023 - Dec 2024",
          location: "Colombo, Sri Lanka ",
          description:
            "Worked collaboratively with the SenzAgro software development team. Contributed to the development of new requirements for the SenzAgro Web App and Moblie app using technologies such as Spring boot ,MongoDB, React JS and React Native. Automated the deployment process using Jenkins and Ansible.  Implemented Microserive architecture for the backend services. ",
          color: "#000000",
        },
        {
          title: "Online Maths Tutor (Part Time / Remote)",
          company: "Thrid Space Gobal  ",
          company_url: "https://www.thirdspaceglobal.com/",
          logo_path: "tsg.png",
          duration: "June 2022 - Aug 2023",
          location: "Colombo, Sri Lanka",
          description:
            "Worked as an online maths tutor for students in the UK. Conducted online classes for students in the UK. Prepared and delivered lessons to a range of classes of different ages and abilities. Marked work, gave appropriate feedback and maintained records of pupils' progress and development. ",
          color: "#0879bf",
        },
        // {
        //   title: "Android and ML Developer",
        //   company: "Muffito Incorporation",
        //   company_url: "https://www.linkedin.com/company/muffito-inc/about/",
        //   logo_path: "muffito_logo.png",
        //   duration: "May 2018 - Oct 2018",
        //   location: "Pune, Maharashtra",
        //   description:
        //     "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
        //   color: "#9b1578",
        // },
        // {
        //   title: "Android Developer",
        //   company: "FreeCopy Pvt. Ltd.",
        //   company_url: "https://www.linkedin.com/company/freecopy/about/",
        //   logo_path: "freecopy_logo.png",
        //   duration: "Nov 2017 - Dec 2017",
        //   location: "Ahmedabad, Gujarat",
        //   description:
        //     "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
        //   color: "#fc1f20",
        // },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Full Stack Developer Intern",
          company: "Senzmate ",
          company_url: "https://www.senzmate.com/",
          logo_path: "senzmate.png",
          duration: "Jan 2022 - Dec 2022",
          location: "Colombo, Sri Lanka",
          description:
            "Worked as a Full Stack Developer Intern at Senzmate. Worked on the development of the SenzAgro Web App and Mobile App. Developed new features and fixed bugs in the existing codebase. Worked on the integration of the backend services with the frontend. ",
          color: "#000000",
        },
        // {
        //   title: "Data Science Research Intern",
        //   company: "Delhivery Pvt. Ltd.",
        //   company_url: "https://www.delhivery.com/",
        //   logo_path: "delhivery_logo.png",
        //   duration: "May 2019 - Sept 2019",
        //   location: "Gurgaon, Haryana",
        //   description:
        //     "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
        //   color: "#ee3c26",
        // },
        // {
        //   title: "Data Science Intern",
        //   company: "Intel Indexer LLC",
        //   company_url:
        //     "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
        //   logo_path: "intel_logo.jpg",
        //   duration: "Nov 2018 - Dec 2018",
        //   location: "Work From Home",
        //   description:
        //     "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
        //   color: "#0071C5",
        // },
      ],
    },
    // // {
    // //   title: "Volunteerships",
    // //   experiences: [
    // //     {
    // //       title: "Google Explore ML Facilitator",
    // //       company: "Google",
    // //       company_url: "https://about.google/",
    // //       logo_path: "google_logo.png",
    // //       duration: "June 2019 - April 2020",
    // //       location: "Hyderabad, Telangana",
    // //       description:
    // //         "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
    // //       color: "#4285F4",
    // //     },
    // //     {
    // //       title: "Microsoft Student Partner",
    // //       company: "Microsoft",
    // //       company_url: "https://www.microsoft.com/",
    // //       logo_path: "microsoft_logo.png",
    // //       duration: "Aug 2019 - May 2020",
    // //       location: "Hyderabad, Telangana",
    // //       description:
    // //         "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
    // //       color: "#D83B01",
    // //     },
    // //     {
    // //       title: "Mozilla Campus Captain",
    // //       company: "Mozilla",
    // //       company_url: "https://www.mozilla.org/",
    // //       logo_path: "mozilla_logo.png",
    // //       duration: "Oct 2019 - May 2020",
    // //       location: "Kurnool, Andhra Pradesh",
    // //       description:
    // //         "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
    // //       color: "#000000",
    // //     },
    // //     {
    // //       title: "Developer Students Club Member",
    // //       company: "DSC IIITDM Kurnool",
    // //       company_url:
    // //         "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
    // //       logo_path: "dsc_logo.png",
    // //       duration: "Jan 2018 - May 2020",
    // //       location: "Kurnool, Andhra Pradesh",
    // //       description:
    // //         "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
    // //       color: "#0C9D58",
    // //     },
    // //     {
    // //       title: "Developer Program Member",
    // //       company: "Github",
    // //       company_url: "https://github.com/",
    // //       logo_path: "github_logo.png",
    // //       duration: "July 2019 - PRESENT",
    // //       location: "Work From Home",
    // //       description:
    // //         "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
    // //       color: "#181717",
    // //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "sajeenthiran.jpeg",
    description:
      " I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
    telephone: "+94 77 289 7834  ",
    email :" sajeenthiranp.21@cse.mrt.ac.lk / psajeendran@gmail.com ",
    address : "No 210/B/4 ,Samupakara Mw , Honnanthara North , Piliyandala"
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Saratoga Ave, San Jose, CA, USA 95129",
    locality: "San Jose",
    country: "USA",
    region: "California",
    postalCode: "95129",
    streetAddress: "Saratoga Avenue",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
